<template>
    <table class="table table-striped">
        <thead>
        <tr>
            <th scope="col">Title</th>
            <th scope="col">Start Time</th>
            <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="webcast in webcasts">
            <td>{{webcast.name }}</td>
            <td>{{webcast.start_at }}</td>
            <td align="right"><a :href="'/webcast/'+ webcast.uuid +'/manage'" class="btn btn-sm btn-primary">Manage</a></td>
        </tr>
        </tbody>
    </table>
</template>

<script>
	export default {
		name: "WebcastListComponent",
        data() {
		    return {
		        webcasts: []
            }
        },
        mounted() {
            axios.get('/api/webcast').then((response) => {
                this.webcasts = response.data.webcasts
            }).catch((error) => {
            });
        }
	}
</script>

<style scoped>

</style>
